import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "replenish-dialog-content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "紹介報酬（TiktokShop講座）")
], -1)
const _hoisted_3 = { class: "table" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 【第2期】TikTok Shopライブ講座｜実践に直結する内容へアップデート ")
const _hoisted_5 = { style: {} }
const _hoisted_6 = { class: "submit-btn" }

import { t } from '@/plugins/i18n'
import { ref, watch } from 'vue'
import { request } from '@/config/request/interceptors'
import { PayOrderRespDTO } from '@/service/settlement'
import { formatMoney } from '@/plugins/utils'

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const dataSource = ref<PayOrderRespDTO[]>([])
const dialogVisible = ref(false)
const pageQuery = ref({
  total: 100,
  pageSize: 10,
  pageNum: 1
})
const _paginationConfig = ref({
  total: 0,
  current: 1,
  pageSize: 10,
  pageSizes: [10, 20, 30, 50],
  layout: ' prev, pager, next, sizes, jumper ',
  background: true
})
watch(pageQuery.value, (newValue, oldValue) => {
  if (newValue.pageSize !== oldValue.pageSize) {
    pageQuery.value.pageNum = 1
  }
  if (newValue.pageNum === oldValue.pageNum && newValue.pageSize === oldValue.pageSize) return
  getList()
})
const getList = async () => {
  const res = await request.settlement.pay.orderInviteList({
    pageSize: pageQuery.value.pageSize,
    pageNum: pageQuery.value.pageNum
  })
  dataSource.value = res.data?.records || []
  pageQuery.value.total = res.data?.total || 0
}

expose({
  show: () => {
    pageQuery.value.pageNum = 1
    getList()
    dialogVisible.value = true
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialogVisible).value = $event)),
    width: "500",
    "custom-class": "replenish-dialog",
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    zIndex: 3009
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_el_divider),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_table, {
            data: dataSource.value,
            style: {"width":"100%"},
            height: 400
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "mainCustomerId",
                label: "メインアカウントID"
              }),
              _createVNode(_component_el_table_column, {
                prop: "payTime",
                label: "支払日時"
              }),
              _createVNode(_component_el_table_column, {
                prop: "historyReplenishQuantity",
                label: "支払内容"
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "cancelReplenishQuantity",
                label: "支払金額"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(_unref(formatMoney)(scope.row.payAmount)) + "円 ", 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_pagination, _mergeProps(_paginationConfig.value, {
              total: pageQuery.value.total,
              pageSize: pageQuery.value.pageSize,
              "onUpdate:pageSize": _cache[0] || (_cache[0] = ($event: any) => ((pageQuery.value.pageSize) = $event)),
              currentPage: pageQuery.value.pageNum,
              "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((pageQuery.value.pageNum) = $event)),
              style: {"justify-content":"flex-end","margin-top":"20px"}
            }), null, 16, ["total", "pageSize", "currentPage"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: "btn-pay",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (dialogVisible.value = false))
          }, _toDisplayString(_unref(t)('关闭')), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})